import { render } from "./Tutorial.vue?vue&type=template&id=f2fe8aa2&scoped=true"
import script from "./Tutorial.vue?vue&type=script&lang=js"
export * from "./Tutorial.vue?vue&type=script&lang=js"

import "./Tutorial.vue?vue&type=style&index=0&id=f2fe8aa2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f2fe8aa2"

export default script